import React from 'react';
import { Cpu } from 'lucide-react';
export function Technology() {
  return <section className="py-24 bg-[#0a0a0a] border-y border-white/5 relative overflow-hidden" data-id="element-103">
      {/* Tech Background Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#00E5FF 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-104" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-105">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#FFD700]/10 border border-[#FFD700]/30 mb-8" data-id="element-106">
          <Cpu className="w-4 h-4 text-[#FFD700]" data-id="element-107" />
          <span className="text-sm font-bold text-[#FFD700] tracking-widest uppercase" data-id="element-108">
            Propietario
          </span>
        </div>

        <h2 className="text-4xl md:text-6xl font-black mb-8 leading-tight" data-id="element-109">
          Infraestructura <br className="hidden md:block" data-id="element-110" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-400 to-white" data-id="element-111">
            Impulsada por IA
          </span>
        </h2>

        <p className="text-2xl md:text-3xl text-gray-300 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-112">
          "Nosotros pagamos el software de vanguardia,{' '}
          <br className="hidden md:block" data-id="element-113" />
          <span className="text-[#00E5FF] font-medium glow-text" data-id="element-114">
            tú recibes toda la potencia."
          </span>
        </p>
      </div>
    </section>;
}